//SERVER ROUTES
export const USER_SERVER = '/api/users';
export const CHAT_SERVER = '/api/chat';
export const BASEURL = "https://devapi.edves.net/studentapi/public/v1";
// export const BASEURL = "http://localhost/StudentApp2/public/v1";
